import { Plugin } from '@ckeditor/ckeditor5-core';
import RecorderLoadObserver from './recorderloadobserver';
import InsertRecorderCommand from './insertrecordercommand';
import RecorderUtils from '../recorderutils';

export default class RecorderEditing extends Plugin {
    static get requires() {
        return [ RecorderUtils ];
    }

    static get pluginName() {
        return 'RecorderEditing';
    }

    init() {
        const editor = this.editor;
        const conversion = editor.conversion;

        // Observa cuando <audio>/<video> terminan de cargar en la vista
        editor.editing.view.addObserver(RecorderLoadObserver);

        // Upcast atributos básicos desde HTML → Modelo
        conversion.for('upcast').attributeToAttribute({
            view: { name: /^(audio|video)$/, key: 'src' },
            model: 'src'
        });

        conversion.for('upcast').attributeToAttribute({
            view: { name: /^(audio|video)$/, key: 'controls' },
            model: 'controls'
        });

        conversion.for('upcast').attributeToAttribute({
            view: { name: /^(audio|video)$/, key: 'type' },
            model: 'type'
        });

        // Comando para insertar un recorder (audio o video)
        const insertRecorderCommand = new InsertRecorderCommand(editor);
        editor.commands.add('insertRecorder', insertRecorderCommand);
        editor.commands.add('recorderInsert', insertRecorderCommand);
    }
}

/**
 * Crea el contenedor <figure class="recorder"> con <audio> o <video>.
 * Si el width del modelo es "Original" o no está definido, el elemento se mostrará con width:100%.
 */
export function createRecorderViewElement(writer, modelElement) {
    const type = modelElement.getAttribute('type') || 'audio'; // "audio" | "video"
    const src = modelElement.getAttribute('src') || '';
    const width = modelElement.getAttribute('width') || 'Original';
    const alignment = modelElement.getAttribute('alignment');

    let mediaEl;

    if (type === 'audio') {
        // Audio simple
        mediaEl = writer.createEmptyElement('audio', {
            controls: 'controls',
            controlslist: 'nodownload',
            preload: 'metadata',
            class: 'nomediaplugin',
            src
        });
    } else {
        // Video con <source>
        mediaEl = writer.createContainerElement('video', {
            controls: 'controls',
            controlslist: 'nodownload',
            preload: 'metadata',
            class: 'nomediaplugin'
        });

        const sourceEl = writer.createEmptyElement('source', { src });
        writer.insert(writer.createPositionAt(mediaEl, 0), sourceEl);
    }

    // Contenedor principal: siempre figure.recorder
    const attrs = { class: 'recorder' };
    if (type === 'audio') {
        attrs.class += ' recorder-audio';
    }

    const container = writer.createContainerElement('figure', attrs);
    writer.insert(writer.createPositionAt(container, 0), mediaEl);

    // === Mostrar el ancho visual ===
    if (width === 'Original' || !width) {
        writer.setStyle('width', '100%', container);
    } else {
        writer.setStyle('width', width, container);
        writer.addClass('recorder_resized', container);
    }

    // === Aplicar alineación si existe ===
    if (alignment) {
        writer.addClass(`recorder-style-align-${alignment}`, container);
    }

    return container;
}
